export default Object.freeze({
    Approve: 0,
    Refuse: 1,
    PublishBid: 2,
    CancelBid: 3,
});
